var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1231_6585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.5H11.5C11.5 0.5 12 0.5 12 1V12.3333C12 12.3333 12 12.8333 11.5 12.8333H1.5C1.5 12.8333 1 12.8333 1 12.3333V1C1 1 1 0.5 1.5 0.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.1665V14.9998C14.9983 15.1319 14.945 15.2581 14.8516 15.3515C14.7582 15.4449 14.6321 15.4981 14.5 15.4998H5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.1665H1",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 10.1669L6.79992 5.21357C6.88673 5.08895 7.00078 4.98574 7.13342 4.91177C7.26607 4.83781 7.41381 4.79502 7.56546 4.78667C7.7171 4.77832 7.86865 4.80461 8.00862 4.86356C8.14858 4.92251 8.27328 5.01257 8.37325 5.1269L11.9999 9.33357",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 2.5C4.19778 2.5 4.39112 2.55865 4.55557 2.66853C4.72002 2.77841 4.84819 2.93459 4.92388 3.11732C4.99957 3.30004 5.01937 3.50111 4.98079 3.69509C4.9422 3.88907 4.84696 4.06725 4.70711 4.20711C4.56725 4.34696 4.38907 4.4422 4.19509 4.48079C4.00111 4.51937 3.80004 4.49957 3.61732 4.42388C3.43459 4.34819 3.27841 4.22002 3.16853 4.05557C3.05865 3.89112 3 3.69778 3 3.5C3 3.23478 3.10536 2.98043 3.29289 2.79289C3.48043 2.60536 3.73478 2.5 4 2.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1231_6585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.4b972e4680c6f6f581d18b9f635d3490.svg";
export { ForwardRef as ReactComponent };